import React from 'react';
import { Popup } from "../../design_system/components/Popup/Popup";

export const AnConfirmPopup = ({
    name = "Confirmation",
    onSubmitCallback,
    onCancelCallback,
    confirm_message,
    btnLabels = { submitLabel: 'Export', cancelLabel: 'Cancel' },
    isLoading = false,
    show = true,
    maxWidth = 350,
    props,
}) => {
    let message = confirm_message || `Do you want to export ${name}`;
    let { submitLabel, cancelLabel } = btnLabels;

    return (
        <Popup
            name={name}
            handleOnClosePopup={onCancelCallback}
            show={show}
            maxWidth={maxWidth}
            showHeaderDivider={false}
            showFooterDivider={false}
            primaryAction={{
                label: submitLabel,
                onClick: onSubmitCallback,
                isLoading: isLoading
            }}
            secondaryAction={{
                label: cancelLabel,
                onClick: onCancelCallback
            }}
            
        >
            <div className="body-l-semibold">
                {message}
            </div>
        </Popup>
    );
};